module.exports = __webpack_public_path__ + "static/media/wallpaper3.efc4abb5.jpg";